module.exports = __webpack_public_path__ + "static/fonts/DejaVuSans.49c0f03.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/DejaVu/DejaVuSans.ttf?v=1.1
// module id = 1633
// module chunks = 28